<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter" id="heading_id_2">6</h2>
<p class="noindent">Michael Chambers was in such a deep sleep he had hardly moved since lying down on the cot. In the past two days his body had been subjected to the type of trauma that would ordinarily take weeks to recover from. But for the time being, a few hours of uninterrupted sleep would have to suffice.</p>
<p>At the moment, he saw himself wading barefoot through a rose garden. There were bright reds, whites, yellows, pinks... colors and varieties of roses such that he had never seen before. He stopped and looked down at his feet, which were standing in the cool, moist peat moss. A sweet scent hung on the air and he sucked it in deeply, filling his lungs with the competing aromas.</p>
<p>He looked down again—and saw deep gashes across his feet, blood oozing everywhere, as if the thorns from the rosebushes had swarmed his bare legs and sliced the skin to shreds. He bolted upright in bed, instantly awake, and realized he was dreaming.</p>
<p>As he struggled to see his feet in the dark, the door opened and light spilled into the small room, creating a tall, thin shadow on the wall next to the cot.</p>
<p>Chambers threw a hand up to his eyes to block the light. He looked around, still agitated from the nightmare, dizzy and completely disoriented. “What are you doing?” he shouted.</p>
<p>His visitor, dressed in a light blue uniform, closed the door slightly and the room darkened again. “Sorry, sir, hospital security. I—I didn’t mean to wake you, but a patient’s taken off and he’s wanted for questioning by the police. We’ve got orders to search all rooms. Nobody’s come in, I take it.”</p>
<p>“I’ve been on for thirty-three hours straight,” Chambers said, recalling what Dr. Farber had said to him. “I’ve been dead to rights ever since I fell asleep.”</p>
<p>The man nodded, pulled out his flashlight, and swung it around the room beneath the three cots. “Okay. All clear.” He apologized again for disturbing him and left.</p>
<p><em>Shit.</em> They were searching the entire hospital. He wouldn’t be able to leave, at least not for a while. But since this room had already been checked, he would hopefully not have to pass the scrutiny of a real cop, one who wouldn’t be so easily dissuaded with a physician’s woeful story of exhaustion.</p>
<p>He lay back, closed his eyes, and within seconds was drifting off again to a deep sleep.</p>
<p class="break"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?6ef525ac